import * as React from "react";

export class PulseBetButton extends React.Component<{
    modifier?: string,
    isDisabled?: boolean,
    handler?: (event: React.MouseEvent<HTMLElement>) => void
}, {}> {

    render() {
        const cls = this.props.modifier ? " rj-my-pulse-bets__pulse-btn--" + this.props.modifier : "";
        return (
            <button type="button" className={`rj-my-pulse-bets__pulse-btn${cls}`}
                onClick={this.props.handler} disabled={this.props.isDisabled}>
                {this.props.children}
            </button>
        )
    }
}